module.exports = __webpack_public_path__ + "img/line.a86045a4.png";